/**
 * Slugify a heading / TOC label into a URL-hash anchor id.
 *
 * Lowercase; whitespace and underscores become a hyphen; every OTHER
 * non-alphanumeric character is DROPPED (not turned into a hyphen), so an
 * apostrophe collapses cleanly — `"Artist's Corner" → "artists-corner"`, not
 * `"artist-s-corner"`. Runs of hyphens are collapsed and the edges trimmed.
 *
 * This is the single source of truth for anchor slugs. Both the portable-text
 * chapter renderer (which emits a chapter's `<span id>`) and the tutorial TOC /
 * rail (which builds the `#anchor` those links point at) call it, so a rendered
 * id and the fragment that targets it are always byte-identical. Keep them
 * unified — the two used to diverge (the TOC hyphenated specials while the
 * renderer dropped them), which broke deep-links to any heading with an
 * apostrophe or other punctuation.
 */
export function slugifyAnchor(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[\s_]+/g, '-') // whitespace / underscores → hyphen
    .replace(/[^a-z0-9-]/g, '') // drop everything else
    .replace(/-+/g, '-') // collapse runs
    .replace(/^-+|-+$/g, '') // trim
}
